import React from 'react';
import BaseIcon from '../base-icon';

const ChevronDown = (props) => (
  <BaseIcon viewBox="2 2 24 24" {...props} scalable>
    <path d="M14 19a.47.47 0 01-.35-.15l-7-7a.49.49 0 01.7-.7L14 17.79l6.65-6.64a.49.49 0 11.7.7l-7 7A.47.47 0 0114 19z" />
  </BaseIcon>
);

export default ChevronDown;
